module.exports = __webpack_public_path__ + "img/0028.e2dbc1d4.gif";